require('../../modules/es7.string.pad-end');
module.exports = require('../../modules/_core').String.padEnd;



// WEBPACK FOOTER //
// ./~/@babel/polyfill/~/core-js/fn/string/pad-end.js